// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ReadMoreSeries_container__aja9c {
    width: 100%;
    padding: 2rem 1rem;
    background-color: #000;
    color: #fff;
    min-height: 100vh;
  }
  
  .ReadMoreSeries_boxContainer__Apw1k {
    max-width: 1200px;
    margin: 0 auto;
  }
  
  .ReadMoreSeries_title__aarOd {
    font-size: 2.5rem;
    margin-bottom: 2rem;
    color: #ff0000;
    text-align: center;
    text-transform: uppercase;
    font-weight: 700;
    letter-spacing: 1px;
    border-bottom: 2px solid #ff0000;
    padding-bottom: 0.5rem;
  }
  
  .ReadMoreSeries_gridContainer__5rD4r {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 1.5rem;
  }
  
  /* Responsive grid layouts */
  @media (min-width: 576px) {
    .ReadMoreSeries_gridContainer__5rD4r {
      grid-template-columns: repeat(2, 1fr);
    }
  }
  
  @media (min-width: 768px) {
    .ReadMoreSeries_gridContainer__5rD4r {
      grid-template-columns: repeat(4, 1fr);
    }
  }
  
  @media (min-width: 992px) {
    .ReadMoreSeries_gridContainer__5rD4r {
      grid-template-columns: repeat(5, 1fr);
    }
  }
  
  .ReadMoreSeries_gridItem__RZq0d {
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 4px 10px rgba(255, 0, 0, 0.2);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    background-color: #111;
    height: 100%;
  }
  
  .ReadMoreSeries_gridItem__RZq0d:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 20px rgba(255, 0, 0, 0.4);
  }
  
  .ReadMoreSeries_imageContainer__agSfG {
    position: relative;
    width: 100%;
    height: 270px;
    overflow: hidden;
  }
  
  .ReadMoreSeries_image__em0Uj {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.5s ease;
  }
  
  .ReadMoreSeries_gridItem__RZq0d:hover .ReadMoreSeries_image__em0Uj {
    transform: scale(1.05);
  }
  
  .ReadMoreSeries_overlay__xBalQ {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background: linear-gradient(to top, rgba(0, 0, 0, 0.9) 0%, transparent 100%);
    padding: 1.5rem 1rem 1rem;
    transition: opacity 0.3s ease;
  }
  
  .ReadMoreSeries_bookTitle__dTCnV {
    color: #fff;
    font-size: 1.2rem;
    margin-bottom: 0.5rem;
    font-weight: 600;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  
  .ReadMoreSeries_genre__SAHMX {
    color: #ff0000;
    font-size: 0.9rem;
    font-weight: 500;
    margin-bottom: 0.5rem;
  }
  
  .ReadMoreSeries_pagination__sWTQQ {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 2.5rem;
    gap: 1rem;
  }
  
  .ReadMoreSeries_pageButton__QW\\+iI {
    background-color: #222;
    color: #fff;
    border: 2px solid #ff0000;
    padding: 0.5rem 1rem;
    border-radius: 4px;
    cursor: pointer;
    font-weight: 600;
    transition: all 0.3s ease;
  }
  
  .ReadMoreSeries_pageButton__QW\\+iI:hover:not(:disabled) {
    background-color: #ff0000;
    color: #fff;
  }
  
  .ReadMoreSeries_pageButton__QW\\+iI:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    border-color: #666;
  }
  
  .ReadMoreSeries_pageIndicator__-SS\\+W {
    color: #fff;
    font-weight: 500;
  }
  
  .ReadMoreSeries_nextButton__iH2WI {
    background-color: #ff0000;
  }
  
  .ReadMoreSeries_loadingContainer__xmay1 {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 50vh;
    background-color: #000;
  }
  
  .ReadMoreSeries_loadingSpinner__0N4C1 {
    width: 50px;
    height: 50px;
    border: 5px solid #222;
    border-radius: 50%;
    border-top-color: #ff0000;
    animation: ReadMoreSeries_spin__qTFJs 1s ease-in-out infinite;
  }
  
  @keyframes ReadMoreSeries_spin__qTFJs {
    to {
      transform: rotate(360deg);
    }
  }
  
  .ReadMoreSeries_errorContainer__Pn6gT {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 50vh;
    background-color: #000;
    color: #ff0000;
    text-align: center;
    padding: 2rem;
  }
  
  .ReadMoreSeries_premiumBadge__aQL5L {
    display: inline-block;
    background-color: #ff0000;
    color: #fff;
    font-size: 0.75rem;
    padding: 0.25rem 0.5rem;
    border-radius: 4px;
    margin-top: 0.5rem;
    font-weight: 600;
    text-transform: uppercase;
  }`, "",{"version":3,"sources":["webpack://./src/AudioSeries/Components/CSS/ReadMoreSeries.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,mBAAmB;IACnB,gCAAgC;IAChC,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,qCAAqC;IACrC,WAAW;EACb;;EAEA,4BAA4B;EAC5B;IACE;MACE,qCAAqC;IACvC;EACF;;EAEA;IACE;MACE,qCAAqC;IACvC;EACF;;EAEA;IACE;MACE,qCAAqC;IACvC;EACF;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,2CAA2C;IAC3C,qDAAqD;IACrD,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,2BAA2B;IAC3B,4CAA4C;EAC9C;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,+BAA+B;EACjC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,4EAA4E;IAC5E,yBAAyB;IACzB,6BAA6B;EAC/B;;EAEA;IACE,WAAW;IACX,iBAAiB;IACjB,qBAAqB;IACrB,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;EAC9B;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,WAAW;IACX,yBAAyB;IACzB,oBAAoB;IACpB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,yBAAyB;IACzB,6DAAuC;EACzC;;EAEA;IACE;MACE,yBAAyB;IAC3B;EACF;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,sBAAsB;IACtB,cAAc;IACd,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,qBAAqB;IACrB,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;EAC3B","sourcesContent":[".container {\n    width: 100%;\n    padding: 2rem 1rem;\n    background-color: #000;\n    color: #fff;\n    min-height: 100vh;\n  }\n  \n  .boxContainer {\n    max-width: 1200px;\n    margin: 0 auto;\n  }\n  \n  .title {\n    font-size: 2.5rem;\n    margin-bottom: 2rem;\n    color: #ff0000;\n    text-align: center;\n    text-transform: uppercase;\n    font-weight: 700;\n    letter-spacing: 1px;\n    border-bottom: 2px solid #ff0000;\n    padding-bottom: 0.5rem;\n  }\n  \n  .gridContainer {\n    display: grid;\n    grid-template-columns: repeat(5, 1fr);\n    gap: 1.5rem;\n  }\n  \n  /* Responsive grid layouts */\n  @media (min-width: 576px) {\n    .gridContainer {\n      grid-template-columns: repeat(2, 1fr);\n    }\n  }\n  \n  @media (min-width: 768px) {\n    .gridContainer {\n      grid-template-columns: repeat(4, 1fr);\n    }\n  }\n  \n  @media (min-width: 992px) {\n    .gridContainer {\n      grid-template-columns: repeat(5, 1fr);\n    }\n  }\n  \n  .gridItem {\n    border-radius: 8px;\n    overflow: hidden;\n    box-shadow: 0 4px 10px rgba(255, 0, 0, 0.2);\n    transition: transform 0.3s ease, box-shadow 0.3s ease;\n    background-color: #111;\n    height: 100%;\n  }\n  \n  .gridItem:hover {\n    transform: translateY(-5px);\n    box-shadow: 0 10px 20px rgba(255, 0, 0, 0.4);\n  }\n  \n  .imageContainer {\n    position: relative;\n    width: 100%;\n    height: 270px;\n    overflow: hidden;\n  }\n  \n  .image {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    transition: transform 0.5s ease;\n  }\n  \n  .gridItem:hover .image {\n    transform: scale(1.05);\n  }\n  \n  .overlay {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    background: linear-gradient(to top, rgba(0, 0, 0, 0.9) 0%, transparent 100%);\n    padding: 1.5rem 1rem 1rem;\n    transition: opacity 0.3s ease;\n  }\n  \n  .bookTitle {\n    color: #fff;\n    font-size: 1.2rem;\n    margin-bottom: 0.5rem;\n    font-weight: 600;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n  }\n  \n  .genre {\n    color: #ff0000;\n    font-size: 0.9rem;\n    font-weight: 500;\n    margin-bottom: 0.5rem;\n  }\n  \n  .pagination {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-top: 2.5rem;\n    gap: 1rem;\n  }\n  \n  .pageButton {\n    background-color: #222;\n    color: #fff;\n    border: 2px solid #ff0000;\n    padding: 0.5rem 1rem;\n    border-radius: 4px;\n    cursor: pointer;\n    font-weight: 600;\n    transition: all 0.3s ease;\n  }\n  \n  .pageButton:hover:not(:disabled) {\n    background-color: #ff0000;\n    color: #fff;\n  }\n  \n  .pageButton:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n    border-color: #666;\n  }\n  \n  .pageIndicator {\n    color: #fff;\n    font-weight: 500;\n  }\n  \n  .nextButton {\n    background-color: #ff0000;\n  }\n  \n  .loadingContainer {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    min-height: 50vh;\n    background-color: #000;\n  }\n  \n  .loadingSpinner {\n    width: 50px;\n    height: 50px;\n    border: 5px solid #222;\n    border-radius: 50%;\n    border-top-color: #ff0000;\n    animation: spin 1s ease-in-out infinite;\n  }\n  \n  @keyframes spin {\n    to {\n      transform: rotate(360deg);\n    }\n  }\n  \n  .errorContainer {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    min-height: 50vh;\n    background-color: #000;\n    color: #ff0000;\n    text-align: center;\n    padding: 2rem;\n  }\n  \n  .premiumBadge {\n    display: inline-block;\n    background-color: #ff0000;\n    color: #fff;\n    font-size: 0.75rem;\n    padding: 0.25rem 0.5rem;\n    border-radius: 4px;\n    margin-top: 0.5rem;\n    font-weight: 600;\n    text-transform: uppercase;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ReadMoreSeries_container__aja9c`,
	"boxContainer": `ReadMoreSeries_boxContainer__Apw1k`,
	"title": `ReadMoreSeries_title__aarOd`,
	"gridContainer": `ReadMoreSeries_gridContainer__5rD4r`,
	"gridItem": `ReadMoreSeries_gridItem__RZq0d`,
	"imageContainer": `ReadMoreSeries_imageContainer__agSfG`,
	"image": `ReadMoreSeries_image__em0Uj`,
	"overlay": `ReadMoreSeries_overlay__xBalQ`,
	"bookTitle": `ReadMoreSeries_bookTitle__dTCnV`,
	"genre": `ReadMoreSeries_genre__SAHMX`,
	"pagination": `ReadMoreSeries_pagination__sWTQQ`,
	"pageButton": `ReadMoreSeries_pageButton__QW+iI`,
	"pageIndicator": `ReadMoreSeries_pageIndicator__-SS+W`,
	"nextButton": `ReadMoreSeries_nextButton__iH2WI`,
	"loadingContainer": `ReadMoreSeries_loadingContainer__xmay1`,
	"loadingSpinner": `ReadMoreSeries_loadingSpinner__0N4C1`,
	"spin": `ReadMoreSeries_spin__qTFJs`,
	"errorContainer": `ReadMoreSeries_errorContainer__Pn6gT`,
	"premiumBadge": `ReadMoreSeries_premiumBadge__aQL5L`
};
export default ___CSS_LOADER_EXPORT___;
